/**
 * @see Common.showMessageContainer
 * @see Common.closeMessageContainer
 * @see Common.setMessages
 */
const Messages = {
    init: () => {
        Messages.$containerInfo = $('.message-container.bg-info');
        Messages.$containerSuccess = $('.message-container.bg-success');
        Messages.$containerWarning = $('.message-container.bg-warning');
        Messages.$containerDanger = $('.message-container.bg-danger');
    },
    __hideContainerMessages: $container => {
        $container
            .removeClass('active')
            .fadeOut()
            .find('div').remove();
    },
    __showMessage: ($container, message) => {
        $container
            .append(
                $('<div />').html(message)
            )
            .addClass('active')
            .fadeIn();
    },
    hideMessages: () => {
        Messages.__hideContainerMessages(Messages.$containerInfo);
        Messages.__hideContainerMessages(Messages.$containerInfo);
        Messages.__hideContainerMessages(Messages.$containerInfo);
        Messages.__hideContainerMessages(Messages.$containerInfo);
    },
    showInfo: message => {
        Messages.__showMessage(Messages.$containerInfo, message);
    },
    showSuccess: message => {
        Messages.__showMessage(Messages.$containerSuccess, message);
    },
    showWarning: message => {
        Messages.__showMessage(Messages.$containerWarning, message);
    },
    showDanger: message => {
        Messages.__showMessage(Messages.$containerDanger, message);
    },
};

$(document).ready(() => {
    Messages.init();
    $('.message-container > button.close').click(ev => {
        Messages.__hideContainerMessages($(ev.target).closest('.message-container'));
    });
});

window.Messages = Messages;